import { MapPrefixSeoForProduct } from '@entities/Catalog/module/consts/seoSettings';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useAppSelector } from '@redux/hooks';
import { getParams } from '@entities/Filter';

export const useGetSeoPrefixForProduct = (): string => {
  const router = useRouter();
  const params = useAppSelector(getParams);
  const [prefix, setPrefix] = useState<string>(MapPrefixSeoForProduct[router.pathname] || '');

  useEffect(() => {
    const href = '/catalog/tyres/leto';
    if (window && window.location.href.includes(href)) {
      setPrefix(MapPrefixSeoForProduct[href]);
    } else if (window) {
      setPrefix('');
    }
  }, [params]);

  return prefix;
};
